module.exports = __webpack_public_path__ + "static/fonts/Roboto-Thin.39a5c62.woff2";